<template>
  <div class="l-page l-page--message">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.10.2/fullcalendar.min.css" rel="stylesheet" />
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main-message">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">
            配信カレンダー
          </div>
        </div>
      </div>
      <div style="padding: 32px;">
        <div v-show="isDisplayLimitOver" style="margin-bottom: 20px;">
          表示可能なメッセージ数を超えています。
        </div>
        <FullCalendar ref="fullCalendar" :options="calendarOptions">
          <template #eventContent='arg'>
            <div v-tooltip="arg.event.title">
              <b>{{ arg.timeText }}</b>
              <i>{{ arg.event.title }}</i>
            </div>
          </template>
        </FullCalendar>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  components: {
    FullCalendar,
  },
  data: function () {
    return {
      isDisplayLimitOver: false,
      calendarOptions: {
        headerToolbar: {
          left: "title",
          center: "",
          right: "prev,next today dayGridMonth timeGridWeek timeGridDay",
        },
        buttonText: {
          today: "今日",
          month: "月表示",
          week: "週表示",
          day: "日表示",
        },
        locale: "ja",
        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
        initialView: "dayGridMonth",
        datesSet: this.handleDatesSet,
        events: [
        ],
      }
    };
  },
  mounted() {
  },
  methods: {
    handleDateClick: function (_info) {
    },
    handleDatesSet(_dateInfo) {
      const calendarApi = this.$refs.fullCalendar.getApi();
      const view = calendarApi.view;
      const startDate = view.activeStart.toISOString().slice(0, 10);
      const endDate = view.activeEnd.toISOString().slice(0, 10);
      this.getEvents(startDate, endDate);
    },
    getEvents: function (startDate, endDate) {
      const params = {
        start_date: startDate,
        end_date: endDate
      }
      axios.get("/api/message/schedule", {params: params}).then((response) => {
        if (response.data.result === 'NG') {
          this.isDisplayLimitOver = true;
          this.calendarOptions.events = [];
          return;
        }
        this.isDisplayLimitOver = false;
        const messages = response.data.messages;
        const events = [];
        messages.forEach((message) => {
          const className = message.ad_flag == 1 ? 'message-schedule-event-ad' : 'message-schedule-event-normal';
          events.push({
            title: message.message_name,
            start: message.send_start_date,
            classNames: [className],
          });
        });
        this.calendarOptions.events = events;
      });
    },
  },
};
</script>

<style>
.message-schedule-event-normal {
    padding: 4px !important;
    background-color: #3cb6d2 !important;
}
.message-schedule-event-ad {
    padding: 4px !important;
    background-color: #f2657f !important;
}
.fc-button {
    background-color: white !important;
    color: black !important;
    line-height: 0 !important;
    padding: 0 8px !important;
    font-size: 1.2rem !important;
}
</style>
